import { useEffect } from 'react';

export default (callback: () => Promise<unknown>, dependencies = undefined): void =>
  useEffect(() => {
    (async () => {
      await callback();
    })();
  }, dependencies);
